/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable array-callback-return */
import { Cart } from "@insite/client-framework/Services/CartService";
import { CartLineModel } from "@insite/client-framework/Types/ApiModels";
import { LinkProps } from "@insite/mobius/Link/Link";

interface DataLayerItem {
    coupon?: string;
    currency?: string;
    discount?: number;
    index?: number;
    item_category?: string;
    item_category2?: string;
    item_category3?: string;
    item_category4?: string;
    item_category5?: string;
    item_list_id?: string;
    item_list_name?: string;
    item_variant?: string;
    location_id?: string;
    item_id: string;
    item_name: string;
    item_brand: string;
    price?: number;
    quantity: number | null;
    [key: string]: any;
}

const generateSingleItemArray = (
    product: CartLineModel,
    breadcrumbsLinks: LinkProps[] | undefined,
    qtyOrdered: number,
) => {
    const itemArr = [];
    const listName = product.properties.categories;
    const updatedListName = listName.slice(0, listName.length - 1);

    const obj: DataLayerItem = {
        item_id: product.erpNumber ?? "",
        item_name: product.altText,
        item_brand: product.brand?.name || "",
        price: product.pricing?.unitNetPrice,
        quantity: qtyOrdered,
        item_list_id: product.id || "",
        item_list_name: updatedListName,
    };

    const categoriesArr: string[] =
        product && product.properties && product.properties.categories
            ? (product.properties?.categories).split(",")
            : [];
    let i = 1;
    if (categoriesArr[categoriesArr.length - 1] === "") {
        categoriesArr.pop();
    }
    if (categoriesArr.length !== 0) {
        const uniqueItems: Record<string, boolean> = {};
        for (const item of categoriesArr) {
            if (!uniqueItems[item]) {
                if (i === 1) {
                    obj.item_category = item;
                    uniqueItems[item] = true;
                } else {
                    obj[`item_category${i}`] = item;
                    uniqueItems[item] = true;
                }
                i++;
            }
        }
    }
    itemArr.push(obj);
    return itemArr;
};

const generateMultipleItemArray = (products: CartLineModel[]) => {
    const itemArr: DataLayerItem[] = [];
    products.forEach((product, index) => {
        const obj: DataLayerItem = {
            item_id: product.erpNumber ?? "",
            item_name: product.altText,
            index,
            item_brand: product.brand?.name || "",
            item_category: "add to cart Category",
            item_list_name: "add to cart list name",
            item_list_id: "add to cart list id",
            price: product.pricing?.unitNetPrice,
            quantity: product.qtyOrdered,
        };
        const categoriesArr: string[] =
            product && product.properties && product.properties.categories
                ? (product.properties?.categories).split(",")
                : [];
        let i = 1;
        if (categoriesArr[categoriesArr.length - 1] === "") {
            categoriesArr.pop();
        }
        if (categoriesArr.length !== 0) {
            const uniqueItems: Record<string, boolean> = {};
            for (const item of categoriesArr) {
                if (!uniqueItems[item]) {
                    if (i === 1) {
                        obj.item_category = item;
                        uniqueItems[item] = true;
                    } else {
                        obj[`item_category${i}`] = item;
                        uniqueItems[item] = true;
                    }
                    i++;
                }
            }
        }
        itemArr.push(obj);
    });
    return itemArr;
};

const generateDataLayer: any = (items: DataLayerItem[] | null, cart: Readonly<Cart> | undefined) => {
    const dataLayer = (window as any).dataLayer || [];
    // console.log("this is datalayer add ", dataLayer);
    if (dataLayer) {
        dataLayer.push({ ecommerce: null });
        dataLayer.push({
            event: "add_to_cart",
            value: cart?.orderGrandTotal,
            ecommerce: {
                items,
            },
        });
        // console.log("add to cart data layer", dataLayer);
    }
    return dataLayer;
};

export const addToCartDataLayer = (
    product: CartLineModel,
    cart: Readonly<Cart> | undefined,
    breadcrumbsLinks: LinkProps[] | undefined,
    qtyOrdered: number,
) => {
    const items = generateSingleItemArray(product, breadcrumbsLinks, qtyOrdered);
    return generateDataLayer(items, cart);
};

export const addAllToCartDataLayer = (productArray: CartLineModel[] | null) => {
    if (productArray) {
        const items = generateMultipleItemArray(productArray);
        return generateDataLayer(items);
    }
};
